var _line, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVinnyBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 14,
    x2: 32,
    y2: 9,
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 7,
    r: 2.5,
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#d6e4ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 28,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#d6e4ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 42,
    height: 38,
    rx: 12,
    fill: "#ffffff",
    stroke: "#91caff",
    strokeWidth: 1.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 18.5,
    width: 33,
    height: 29,
    rx: 8.5,
    fill: "url(#vinnyFace)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 5,
    height: 11,
    rx: 2.5,
    fill: "#ffffff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    width: 5,
    height: 11,
    rx: 2.5,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 41 Q32 43.8 36.5 41",
    stroke: "#ffffff",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    fill: "none"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vinnyFace",
    x1: 15.5,
    y1: 18.5,
    x2: 48.5,
    y2: 47.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4096ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0958d9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinnyBot);
export default __webpack_public_path__ + "static/media/vinny-bot.5bc7c6d040a5747f3a3ab6c85f572a1c.svg";
export { ForwardRef as ReactComponent };